export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const pluralize = (word) => {
  if (word.match(/y$/)) {
    return word.replace(/y$/, "ies");
  } else {
    return `${word}s`;
  }
};
export const singularize = (word) => {
  if (word.match(/ies$/)) {
    return word.replace(/ies$/, "y");
  } else {
    return word.replace(/s$/, "");
  }
};
